import { render, staticRenderFns } from "./BellNotifications.vue?vue&type=template&id=1151d098&scoped=true"
import script from "./BellNotifications.vue?vue&type=script&lang=js"
export * from "./BellNotifications.vue?vue&type=script&lang=js"
import style0 from "./BellNotifications.vue?vue&type=style&index=0&id=1151d098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151d098",
  null
  
)

export default component.exports